export const calcPercent = (a: number, b: number) => {
  const percent = Math.round((a / b) * 100 * 10) / 10
  if (percent === Infinity) return 0
  if (isNaN(percent)) return 0
  return percent
}
